<template>
    <div>

        <div class="sidebar sidebar-style-2">			
			<div class="sidebar-wrapper scrollbar scrollbar-inner">
				<div class="sidebar-content">
					<div class="user">
						<div class="avatar-sm float-left mr-2">
							<img src="assets/img/profile.jpg" alt="..." class="avatar-img rounded-circle">
						</div>
						<div class="info">
							<a data-toggle="collapse" href="#collapseExample" aria-expanded="true">
								<span>
									<span class="user-level limit_huruf_nama">{{profile.nama}}</span>
									<span class="user-level">Administrator</span>
									<span class="caret"></span>
								</span>
							</a>
							<div class="clearfix"></div>

							<div class="collapse in" id="collapseExample">
								<ul class="nav">
									<li>
										<a href="#profile">
											<span class="link-collapse">My Profile</span>
										</a>
									</li>
									
								</ul>
							</div>
						</div>
					</div>
					<ul class="nav nav-primary">
                        <li class="nav-item active">
                            <router-link to="/">
                                <i class="fas">
                                    <img src="assets/img/sf/house.svg" height="24" width="24">
                                </i>
								<p>Home</p>
								<!-- <span class="badge badge-success">4</span> -->
                            </router-link>

						</li>

						<li class="nav-section">
							<span class="sidebar-mini-icon">
								<i class="fa fa-ellipsis-h"></i>
							</span>
							<h4 class="text-section">Components</h4>
						</li>
						
						<li class="nav-item">
							<a data-toggle="collapse" href="#NBM">
								<i class="fas"><img src="assets/img/sf/book-bookmark.svg" height="24" width="24"></i>
								<p ><b>Data Entri</b></p>
								<span class="caret"></span>
							</a>
							<div class="collapse" id="NBM">
								<ul class="nav nav-collapse">
									<li>
										<router-link to="/data_entri_luas_tanaman_padi">
											<span class="sub-item">Luas Tanaman Padi</span>
										</router-link>
									</li>
								</ul>
							</div>
						</li>

						<li class="nav-item">
                            <router-link to="/data_produksi_beras">
                                <i class="fas"><img src="assets/img/sf/box-in.svg" height="24" width="24"></i>
								<p><b>Produksi Beras</b></p>
								<!-- <span class="badge badge-success">4</span> -->
                            </router-link>
						</li>
						<li class="nav-item">
                            <router-link to="/data_luas_tanam_padi">
                                <i class="fas"><img src="assets/img/sf/map.svg" height="24" width="24"></i>
								<p><b>Luas Tanam Padi</b></p>
								<!-- <span class="badge badge-success">4</span> -->
                            </router-link>
						</li>
						<li class="nav-item">
                            <router-link to="/data_laP_gizi">
                                <i class="fas"><img src="assets/img/sf/monitor.svg" height="24" width="24"></i>
								<p><b>Laporan Gizi BKP</b></p>
								<!-- <span class="badge badge-success">4</span> -->
                            </router-link>
						</li>
						<li class="nav-item">
                            <router-link to="/data_panel_harga_pangan">
                                <i class="fas"><img src="assets/img/sf/money.svg" height="24" width="24"></i>
								<p><b>Panel Harga Pangan</b></p>
								<!-- <span class="badge badge-success">4</span> -->
                            </router-link>
						</li>
						<li class="nav-item">
							<a data-toggle="collapse" href="#laporan">
								<i class="fas"><img src="assets/img/sf/layers.svg" height="24" width="24"></i>
								<p ><b>Laporan</b></p>
								<span class="caret"></span>
							</a>
							<div class="collapse" id="laporan">
								<ul class="nav nav-collapse">
									<li>
										<a data-toggle="collapse" href="#analisis_SPKG">
											<span class="sub-item">Analisis SKPG</span>
											<span class="caret"></span>
										</a>
										<div class="collapse" id="analisis_SPKG">
											<ul class="nav nav-collapse subnav">
												<li>
													<router-link to="/lap_spkg_luas_tanaman">
														<span class="sub-item">Ketersediaan Pangan</span>
													</router-link>
												</li>
												<li>
													<router-link to="/lap_spkg_akses_pangan">
														<span class="sub-item">Akses Pangan</span>
													</router-link>
												</li>
												<li>
													<router-link to="/lap_spkg_pemanfaatan_pangan">
														<span class="sub-item">Pemanfaatan Pangan</span>
													</router-link>
												</li>
											</ul>
										</div>
									</li>
								</ul>
							</div>
						</li>
						<li class="nav-item">
							<a data-toggle="collapse" href="#data_master">
								<i class="fas"><img src="assets/img/sf/layers.svg" height="24" width="24"></i>
								<p ><b>Data Master</b></p>
								<span class="caret"></span>
							</a>
							<div class="collapse" id="data_master">
								<ul class="nav nav-collapse">
									<li>
										<router-link to="/ketapang_master_jenis_bahan_pangan">
											<span class="sub-item">M.Jenis Bahan Makanan</span>
										</router-link>
									</li>
									<li>
										<router-link to="/ketapang_master_komoditi">
											<span class="sub-item">M.Komoditi</span>
										</router-link>
									</li>
									<li>
										<router-link to="/ketapang_master_lumbung_pangan">
											<span class="sub-item">M.Lumbung Pangan</span>
										</router-link>
									</li>
									<li>
										<router-link to="/ketapang_master_provinsi">
											<span class="sub-item">M.Provinsi</span>
										</router-link>
									</li>
									<li>
										<router-link to="/ketapang_master_kab">
											<span class="sub-item">M.Kabupaten</span>
										</router-link>
									</li>
									<li>
										<router-link to="/ketapang_master_kecamatan">
											<span class="sub-item">M.Kecamatan</span>
										</router-link>
									</li>
									<li>
										<router-link to="/ketapang_master_desa">
											<span class="sub-item">M.Desa/Kelurahan</span>
										</router-link>
									</li>
									<li>
										<a data-toggle="collapse" href="#master_value">
											<span class="sub-item">Master Value</span>
											<span class="caret"></span>
										</a>
										<div class="collapse" id="master_value">
											<ul class="nav nav-collapse subnav">
												<li>
													<router-link to="/ketapang_master_bobot_data_produksi">
														<span class="sub-item">Value Produksi</span>
													</router-link>
												</li>
											</ul>
										</div>
									</li>
								</ul>
							</div>
						</li>


						<!-- ===================================================== BUAT DINAS ======================================================== -->
						

						<li class="nav-item">
                            <router-link to="/about">
                                <i class="fas"><img src="assets/img/sf/brick.svg" height="24" width="24"></i>
								<p><b>About</b></p>
								<!-- <span class="badge badge-success">4</span> -->
                            </router-link>

						</li>
						
						<li class="mx-4 mt-2">
							<a class="btn btn-primary btn-block" @click="logout()">
								<span class="btn-label mr-2"><i class="fas"><img src="assets/img/sf/lock.svg" height="24" width="24"></i></span>
								Keluar
							</a>
						</li>
					</ul>
				</div>
			</div>
		</div>





    </div>
</template>

<script>

    // import "https://code.jquery.com/jquery-2.2.4.js";
    // import Moment from 'moment'

    export default {
        name: 'monev_left_sidebar',
        data () {
            return {
                user: "",
                profile : {
					nama : '',
					nip : '',
				},
                // inilah : this.$session.get('MENU')

            }
        },
        methods : {
            logout : function(){
                localStorage.removeItem('token');
                localStorage.removeItem('profile');
                this.$router.push('/login');
            },

            get_user : function(){
                fetch(URL_APP, {
                    headers: {
                        authorization: "kikensbatara " + localStorage.token
                }
                }).then(res => res.json())
                .then(result => {
                    if (result.user) {
                    this.user = result.user;
                    this.profile = result.user.profile;
                    localStorage.profile = JSON.stringify(result.user);
                    // console.log(localStorage.profile);

                    } else {
                        this.logout();
                    }
                });
            },


        },
        mounted: function(){
            var get_profile = JSON.parse(localStorage.profile);
            this.profile.nama = get_profile.profile.nama;
            this.profile.nip = get_profile.profile.ref_instansi;


        },


    }
</script>
